import React from "react";
import { Spinner, Colors, useTheme } from "@zapier/design-system";
import { PAYPAL_BUTTON_ID } from "../constants";

/* Rebrand cleanup required */
const buttonCss = {
  alignItems: "center",
  background: "#009cde",
  borderRadius: 4,
  color: Colors.white,
  display: "flex",
  height: 49,
  justifyContent: "center",
  position: "relative",
  minWidth: 250,
} as const;

const rebrandButtonCss = {
  alignItems: "center",
  background: "#ffc439",
  borderRadius: 3,
  color: Colors.white,
  display: "flex",
  height: 44,
  justifyContent: "center",
  position: "relative",
  minWidth: 250,
} as const;

type Props = {
  /** show loading indicator */
  isLoading: boolean;
};

const PaypalButtonPlaceholder = (props: Props) => {
  const { isRebrand } = useTheme();
  return (
    <div css={isRebrand ? rebrandButtonCss : buttonCss} id={PAYPAL_BUTTON_ID}>
      {props.isLoading && <Spinner />}
    </div>
  );
};

export default PaypalButtonPlaceholder;
